import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Admin Count field definition
 * Boolean field with Yes/No dropdown for admin count status filtering
 */
export const ADObjectAdminCount = createBooleanSimpleFilterDefinition(
  'admincount',
  'Admin Count'
);
